// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React from 'react';
import clsx from 'clsx';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import Styles from './busySpinner.module.scss';

interface IBusySpinnerPropTypes {
    className?: string | null;
    messageKey: string;
    size?: SpinnerSize;
}

export default function BusySpinner(props: IBusySpinnerPropTypes): JSX.Element {
    return (
        <div className={clsx(Styles.spinnerContainer, props.className)}>
            <div>
                <Spinner
                    ariaLabel={props.messageKey}
                    className={Styles.spinnerStyle}
                    size={(props.size !== undefined) ? props.size : SpinnerSize.medium}
                />
                {props.messageKey}
            </div>
        </div>
    );
}
